import axios from "axios";

export default {
  props: {
    perPage: {
      type: Number,
      default: 20
    },
    currentPage: {
      type: Number,
      default: 1
    },
    manualTriggerContentView: {
      type: Boolean,
      default: false
    },
    triggerContentView: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: Boolean,
      default: true
    },
    maxResponsiveColumns: {
      type: Number,
      default: 4
    },
    horizontalScrollable: {
      type: Boolean,
      default: false
    },
    infiniteScroll: {
      type: Boolean,
      default: false
    },
    hideMatchScore: {
      type: Boolean,
      default: false
    },
    disableMatchScoring: {
      type: Boolean,
      default: false
    },
    hideAiInsights: {
      type: Boolean,
      default: false
    },
    preventVehicleVdpRedirect: {
      type: Boolean,
      default: false
    }

    /*filters: {
      type: [Array, String],
      default: () => []
    },
    scoring: {
      type: [Array, String],
      default: () => []
    },
    sorting: {
      type: [Array, String],
      default: () => []
    },
    options: {
      type: [Object, String],
      default: () => ({})
    }*/
  },
  data() {
    return {
      listings: [],
      page: this.currentPage,
      loading: true,
      loaded: false,
      disableSeeMore: true,
      hideSeeMore: false,
      requestBody: {
        filters: [],
        scoring: [],
        sorting: [],
        options: {
          deduplicate_fields: ["vin"],
          exclude_fields: ["advertiser_account_performance_rollup", "inventory_source_performance_rollup", "product_performance_rollup"]
        }
      },
      totalPossibleScore: 0
    };
  },
  computed: {},
  watch: {
    triggerContentView: function(val) {
      if(val === true && this.manualTriggerContentView) {
        this.listings.forEach(vehicle => {
          this.jfpTrack("ContentView", {
            advertiser_account_id: vehicle.advertiser_account_id,
            inventory_source_id: vehicle.inventory_source_id,
            product_id: vehicle.product_id,
            advertiser_external_content_id: vehicle.external_id
            // advertiser_channel_1: XXX,
            // advertiser_channel_2: XXX,
            // advertiser_channel_3: XXX
          });
        });
      }
    }
  },
  methods: {
    extensionInit() {
      return new Promise((resolve) => {
        this.domElement.filters = this.domElement.filters ?? [];
        this.domElement.scoring = this.domElement.scoring ?? [];
        this.domElement.sorting = this.domElement.sorting ?? [];
        this.domElement.options = this.domElement.options ?? {};

        resolve();
      });
    },
    getVehicles(paginationOverride = null) {
      return new Promise((resolve, reject) => {
        this.disableSeeMore = true;
        this.loading = true;

        this.requestBody.filters = this.domElement.filters;
        this.requestBody.scoring = this.domElement.scoring;
        this.requestBody.sorting = this.domElement.sorting;
        this.requestBody.options = this.domElement.options;

        let thisRequestBody = {
          ...this.requestBody,
          pagination: paginationOverride !== null ? paginationOverride : {
            page: this.page,
            per_page: this.perPage
          }
        };

        // TODO: This will only be applicable if pagination-type props is set to "see more" or whatever
        // If visitor is coming back to same vehicle listings page during their session, attempt to reload all listings already viewed
        if ((this.id == 2 || this.id == 45) && this.listings.length == 0 && this.page == 1 && sessionStorage.getItem(window.location.href + "_numListingsLoaded")) {
          let numListingsAlreadyLoaded = sessionStorage.getItem(window.location.href + "_numListingsLoaded");
          if (numListingsAlreadyLoaded > this.perPage) {
            thisRequestBody.pagination.per_page = numListingsAlreadyLoaded;
            this.page = Math.ceil(numListingsAlreadyLoaded / this.perPage);
          }
        }

        // If not internal publisher account, limit the search to "ContentClick" products only
        if(!["10001", "10002", "10003"].includes(this.publisherAccountId.toString())) {
          thisRequestBody.filters.push({ conversion_goal_event_type_id: { equals: 3 } });
        }

        // Confirm we have our "required" default options set
        if(!('deduplicate_fields' in thisRequestBody.options)) {
          thisRequestBody.options.deduplicate_fields = ["vin"];
        }
        if(!('exclude_fields' in thisRequestBody.options)) {
          thisRequestBody.options.exclude_fields = ["advertiser_account_performance_rollup", "inventory_source_performance_rollup", "product_performance_rollup"];
        }

        // If we have listings loaded, and we are not on the first page, remove any faceting options to improve speed
        if('faceting' in thisRequestBody.options && this.listings.length > 0 && this.page > 1) {
          thisRequestBody.options.faceting = {};
        }

        // Autofill the scoring w/ the visitor profile scoring, if we have it
        if (!this.hideMatchScore && !this.disableMatchScoring && window.localStorage.getItem("carscience-visitor-profile-scoring")) {
          thisRequestBody.options.include_score_field = true;
          thisRequestBody.scoring = [ ...thisRequestBody.scoring, ...JSON.parse(window.localStorage.getItem("carscience-visitor-profile-scoring")) ];
          thisRequestBody.sorting.push({ "_score" : "desc" });
        }

        // Anytime scoring clauses are included, set our total possible score
        this.totalPossibleScore = 0;
        if (!this.hideMatchScore && thisRequestBody.scoring.length > 0) {
          let encounteredFieldsHighestScores = {};
          thisRequestBody.scoring.forEach(scoringClauses => {
            let score = +Object.keys(scoringClauses)[0];
            let scoreField= Object.keys(scoringClauses[Object.keys(scoringClauses)[0]])[0];
            if (scoreField === "product_id") return;
            if (!Object.keys(encounteredFieldsHighestScores).includes(scoreField)) {
              encounteredFieldsHighestScores[scoreField] = score;
            }
            if (score > encounteredFieldsHighestScores[scoreField]) {
              encounteredFieldsHighestScores[scoreField] = score;
            }
          });
          Object.values(encounteredFieldsHighestScores).forEach(fieldScore => {
            this.totalPossibleScore += fieldScore;
          });
        }

        if (thisRequestBody.options && thisRequestBody.options.location_search) {
          thisRequestBody.options.location_search.include_distance_field = true;
        } else if (thisRequestBody.options) {
          thisRequestBody.options.location_search = {
            include_distance_field: true
          };
        } else {
          thisRequestBody.options = {
            location_search: {
              include_distance_field: true
            }
          };
        }

        // Fetch the vehicles
        let vm = this;
        axios.post("https://api-v2.jumpfeed.com/network/publisher/products/vehicles", thisRequestBody)
            .then(function (response) {
              let facets = 'facets' in response.data.metadata ? response.data.metadata.facets : {};
              let vehicles = response.data.data.results;

              vm.$emit('loaded-facets', facets);
              vm.$emit('loaded-vehicles', vehicles);
              vm.$emit('loaded-totals', response.data.data.totals);

              if(vehicles.length > 0) {
                vehicles.forEach(function (vehicle, i) {
                  if(!vm.manualTriggerContentView) {
                    vm.jfpTrack("ContentView", {
                      advertiser_account_id: vehicle.advertiser_account_id,
                      inventory_source_id: vehicle.inventory_source_id,
                      product_id: vehicle.product_id,
                      advertiser_external_content_id: vehicle.external_id
                      // advertiser_channel_1: XXX,
                      // advertiser_channel_2: XXX,
                      // advertiser_channel_3: XXX
                    });
                  }

                  // beautify.mode=ai.auto
                  // vehicles[i].images.unshift("https://image-api.photoroom.com/v2/edit?background.color=transparent&background.scaling=fill&outputSize=2016x1512&padding=15%25&horizontalAlignment=right&shadow.mode=ai.soft&imageUrl=" + vehicle.images[0] + "&apiKey=sandbox_sk_pr_default_e85b26a4bdfa6489a4e72b75a912475e38332f0b")

                  vehicles[i]['estimated_monthly_payment'] = vm.formatNumber(vm.getEstimatedMonthlyVehiclePayment(vehicle.price));
                  if(Math.abs((new Date(vehicle.time_created) - (new Date())) / 36e5) < 168) {
                    vehicles[i]['tags'].unshift({
                      tag: "New Listing",
                      metadata: {},
                      time_created: ""
                    });
                  }

                  /*if(vehicle.mileage / (((new Date().getFullYear()) - vehicle.year) + 0.5) <= 8000) {
                    vehicles[i]['tags'].push({
                      tag: "Low Mileage",
                      metadata: {},
                      time_created: ""
                    });
                  }
                  if(vehicle.mileage / (((new Date().getFullYear()) - vehicle.year) + 0.5) >= 20000) {
                    vehicles[i]['tags'].push({
                      tag: "High Mileage",
                      metadata: {},
                      time_created: ""
                    });
                  }*/

                  vehicles[i].show_match_score = false;
                  vehicles[i].match_score = 0;
                  vehicles[i].full_match_score = 0;
                  if (!vm.hideMatchScore && thisRequestBody.scoring.length > 0 && vm.totalPossibleScore > 0 && 'score' in vehicle) {
                    let matchScore = Math.ceil((vehicle.score / vm.totalPossibleScore) * 100);
                    vehicles[i].full_match_score = matchScore;
                    if (matchScore < 10) matchScore = 10;
                    if (matchScore > 100) matchScore = 100;
                    vehicles[i].show_match_score = true;
                    vehicles[i].match_score = matchScore;
                  }
                });

                vm.listings = vm.listings.concat(vehicles);
                vm.disableSeeMore = false;
                vm.page++;

                sessionStorage.setItem(window.location.href + "_numListingsLoaded", vm.listings.length);
              }

              if(typeof vm.requestBody.topProductId !== "undefined") {
                delete vm.requestBody.topProductId;
              }

              if(vehicles.length < vm.perPage) {
                vm.hideSeeMore = true;
              }

              vm.loading = false;
              vm.loaded = true;

              resolve(true);
            })
            .catch(function (error) {
              console.log(error);
              vm.loading = false;
              reject(error);
            });

      });
    },
    isVdpInterstitial(vehicle) {
      return this.urlParams.get("vdpInter") == 1 && vehicle.conversion_goal_event_type_id == 3;
    },
    navigateToVDP(vehicle, preventWindowOpen = false, delay = false, skipVdpInterstitial = false) {

      /*if (this.id == 2 && vehicle.advertiser_account_id == 1053) {
        if (!this.showConfirmationModal) {
          this.showConfirmationModal = true;
          this.confirmationVehicle = vehicle;
          return;
        }
        else {
          this.showConfirmationModal = false;
        }
      }*/

      this.$emit("vehicle-clicked", vehicle);

      let { ...vehicleLocalStorageEntry } = vehicle;
      delete vehicleLocalStorageEntry.description;
      delete vehicleLocalStorageEntry.features_raw;
      delete vehicleLocalStorageEntry.dealer;
      delete vehicleLocalStorageEntry.product_performance_rollup;
      vehicleLocalStorageEntry.time_clicked = Date.now();

      let existingRecentlyClickedVehicles = window.localStorage.getItem("jfpc-clicked-vehicles") ? JSON.parse(window.localStorage.getItem("jfpc-clicked-vehicles")) : [];
      if(existingRecentlyClickedVehicles.length >= 100) {
        existingRecentlyClickedVehicles = existingRecentlyClickedVehicles.slice(0, 99);
      }
      if(existingRecentlyClickedVehicles.filter(ercv => ercv.product_id == vehicle.product_id).length > 0) {
        existingRecentlyClickedVehicles = existingRecentlyClickedVehicles.filter(ercv => ercv.product_id != vehicle.product_id);
      }
      existingRecentlyClickedVehicles.unshift(vehicleLocalStorageEntry);
      window.localStorage.setItem("jfpc-clicked-vehicles", JSON.stringify(existingRecentlyClickedVehicles));

      window.sessionStorage.setItem(window.location.hostname + "-lastScrollPosition", window.scrollY);

      /*if (this.urlParams.get("carcom") == 1) {
        window.open("carcom_out.php?evid=" + vehicle.external_id, "_blank");
        return;
      }*/

      if(vehicle.conversion_goal_event_type_id == 3) {
        // vdpInter=1: send the visitor to our VDP first instead of straight to the destination. The VDP swaps its lead form
        // for a "See It" button, which calls navigateToVDP(vehicle, false, false, true) to run the original flow below.
        if (this.isVdpInterstitial(vehicle) && !skipVdpInterstitial && !window.location.href.includes("/cfx/")) {
          window.location.href = "https://" + this.subdomain + "/vdp_network.php?pid=" + vehicle.product_id + "&" + this.urlParams.toString();
          return;
        }

        // When called from the VDP's "See It" button we're already on a VDP, so never route back to one.
        let doAnonFlow = this.urlParams.get("anon") == 1 && vehicle.advertiser_account_id != 1052 && !skipVdpInterstitial;
        let doLeadFlow = this.urlParams.get("cfxLd") == 1 && vehicle.advertiser_account_id == 1063 && !skipVdpInterstitial;

        this.jfpTrack("ContentClick", {
          advertiser_account_id: vehicle.advertiser_account_id,
          inventory_source_id: vehicle.inventory_source_id,
          product_id: vehicle.product_id,
          event_value: doAnonFlow ? 0 : vehicle.bid_value
        });

        sessionStorage.setItem(window.location.hostname + "-adClicked", vehicle.advertiser_account_id);

        if (window.location.href.includes("/cfx/")) {
          window.location.href = "https://" + this.subdomain + "/cfx/vdp/?pid=" + vehicle.product_id + "&" + this.urlParams.toString();
          return;
        }

        if (doLeadFlow) {
          window.location.href = "https://" + this.subdomain + "/vdp_network.php?pid=" + vehicle.product_id + "&" + this.urlParams.toString();
        }
        else if (doAnonFlow) {
          window.location.href = "https://" + this.subdomain + "/vdp_network.php?pid=" + vehicle.product_id + "&anon=1&" + this.urlParams.toString();
        }
        else {
          if(this.urlParams.get("jfoid") || this.urlParams.get("utm_campaign")) {
            if(vehicle.business_id == 13) {
              vehicle.destination_url += encodeURIComponent("&channelid=oid_" + (this.urlParams.get("jfoid") !== null ? this.urlParams.get("jfoid") : this.urlParams.get("utm_campaign")));
            }
            else if(vehicle.business_id == 14) {
              vehicle.destination_url += encodeURIComponent("&utm_id=" + (this.urlParams.get("jfoid") !== null ? this.urlParams.get("jfoid") : this.urlParams.get("utm_campaign")));
            }
          }

          if (["6","34"].includes(vehicle.business_id)) {
            let clickId = vehicle.advertiser_account_id + "|" + vehicle.product_id + "|" + (this.urlParams.get("utm_campaign") ?? "0") + "|" + (this.urlParams.get("split") ?? "0") + "|" + (window.localStorage.getItem("jfpc-visitor-id"));
            vehicle.destination_url += encodeURIComponent("&jfcid=" + btoa(clickId));
          }

          let destUrl = vehicle.destination_url;

          /*if (["6","34"].includes(vehicle.business_id) && this.urlParams.get("clkCnfm") != 1) {
            if (this.subdomain === "www.carscience.com") {
              destUrl = "https://" + this.subdomain + "/out/" + vehicle.advertiser_account_id + "?d=" + encodeURIComponent(vehicle.destination_url) + "&dlrn=" + encodeURIComponent(vehicle.dealer.name);
            } else {
              destUrl = "https://" + this.subdomain + "/vehicle_out.php?d=" + encodeURIComponent(vehicle.destination_url) + "&aaid=" + vehicle.advertiser_account_id + "&dlrn=" + encodeURIComponent(vehicle.dealer.name);
            }
          }*/

          if (delay) {
            setTimeout(() => {
              window.location.href = destUrl;
            }, 240);
          }
          else {
            if(preventWindowOpen || this.isFacebookUserAgent()) {
              window.location.href = destUrl;
            } else {
              // window.open(destUrl, "_blank");
              window.location.href = destUrl;
            }
          }
        }
      }
      else if(["4","7"].includes(vehicle.conversion_goal_event_type_id.toString()) && !this.preventVehicleVdpRedirect) {
        // TODO: If the current (verified) domain is not one of our brands, than fallback to listings.carscience.com? (or random other brand?)
        // If start falling back to listings.carscience.com, will increase brand awareness and start getting more organic traffic to it.
        let vdpUrl = "https://" + this.subdomain + "/vdp_network.php?pid=" + vehicle.product_id;
        if(this.subdomain === "www.carscience.com") {
          vdpUrl = "https://www.carscience.com/listing/" + vehicle.product_id;
        }
        else {
          if(this.urlParams.get("jfoid")) {
            vdpUrl += "&jfoid=" + this.urlParams.get("jfoid");
          }
          if(this.urlParams.get("utm_campaign")) {
            vdpUrl += "&utm_campaign=" + this.urlParams.get("utm_campaign");
          }
        }
        window.location.href = vdpUrl;
      }
    },
    getEstimatedMonthlyVehiclePayment(price, percentDown = 0.2, apr = 0.078, term = 72) {
      price = parseInt(price);
      let loanAmount = price - (price * percentDown);
      return Math.round((loanAmount * (apr / 12)) / (1 - Math.pow((1 + (apr/12)), -term)));
    },
    formatNumber(x, abbreviated = false) {
      let formattedNumber = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (abbreviated) {
        formattedNumber = formattedNumber.substring(0, formattedNumber.indexOf(',')).length > 0 ? formattedNumber.substring(0, formattedNumber.indexOf(',')) + 'k' : formattedNumber;
      }
      return formattedNumber;

    }
  }
};